import { useMutation } from '@tanstack/react-query';
import mutationFnFactory from './change-payment-due-date-put-mutation';
export function useChangePaymentDueDatePutMutation({ config, mutationOptions = {} }) {
    return useMutation({
        mutationFn: payload => {
            const { 'cipher.accountId': accountId, accountIdType } = payload;
            const keyProps = {
                accountId,
                accountIdType
            };
            return new Promise((resolve, reject) => {
                const mutationFn = mutationFnFactory(config, keyProps);
                mutationFn(payload)
                    .then(response => {
                    resolve(response);
                })
                    .catch(reject);
            });
        },
        ...mutationOptions
    });
}
